// src/i18n/translations.jsx
export const translations = {
  fr: {
    // Navigation
    nav_title: "Organisation des Femmes pour le Développement",
    nav_mission: "Mission",
    nav_objectifs: "Objectifs",
    nav_structure: "Structure",
    nav_galerie: "Galerie",
    nav_videos: "Vidéos",
    nav_adhesion: "Adhésion",
    nav_contact: "Contact",
    nav_presidence: "Présidence",

    // Hero
    hero_eyebrow: "Volonté · Solidarité · Développement",
    hero_title1: "Des femmes unies",
    hero_title2: "pour un <em>Tchad prospère</em>",
    hero_desc: "L'OFD est une organisation laïque, apolitique et à but non lucratif fondée à N'Djamena, portant les voix des femmes et des communautés vulnérables depuis 2015.",
    hero_btn1: "Rejoindre l'ONG",
    hero_btn2: "Découvrir notre mission",

    // Stats
    stat_foundation: "Année de fondation",
    stat_duration: "Durée de l'organisation",
    stat_headquarters: "Siège social · Tchad",

    // Devise
    devise_tag: "Notre devise",
    devise_title: "Trois mots, une vision",
    devise_will_title: "Volonté",
    devise_will_desc: "Une force agissante qui motive chaque femme, chaque jeune à prendre son destin en main et à s'engager pour une réalité meilleure.",
    devise_solidarity_title: "Solidarité",
    devise_solidarity_desc: "Le lien moral qui unit notre communauté : avancer ensemble, main dans la main, sans discrimination sociale, tribale ou religieuse.",
    devise_dev_title: "Développement",
    devise_dev_desc: "L'ambition durable qui pousse chaque membre à bâtir, construire et réaliser de grandes choses pour le bien commun.",

    // Objectifs
    objectifs_tag: "Nos objectifs",
    objectifs_title: "Ce que nous bâtissons ensemble",
    obj1: "Améliorer les conditions socio-économiques des communautés par la production, la transformation et la commercialisation des produits agricoles et d'élevage.",
    obj2: "Lutter contre la pauvreté par le développement de tous les secteurs dans la région de N'Djamena et les autres régions du Tchad.",
    obj3: "Protéger l'environnement et lutter contre le changement climatique : eau, air, sols, pâturages, milieux urbains.",
    obj4: "Créer des centres de formations professionnelles : menuiserie, informatique, mécanique, agriculture, coiffure, art et culture.",
    obj5: "Promouvoir la cohabitation pacifique, la paix et consolider la solidarité entre les associations et communautés.",
    obj6: "Venir en aide aux personnes sinistrées et réfugiées, et prévenir les épidémies et autres catastrophes.",
    obj7: "Promouvoir l'entrepreneuriat sous toutes ses formes et motiver les jeunes dans les projets de développement durable.",
    obj8: "Lutter contre la délinquance, les divisions régionales, tribales et religieuses, et renforcer les liens de fraternité.",

    // Structure
    structure_tag: "Gouvernance",
    structure_title: "Structure et fonctionnement",
    structure_desc: "L'OFD est structurée autour de quatre organes principaux, chacun avec des attributions précises pour garantir une gestion transparente et efficace.",
    org_ag_title: "Assemblée Générale (AG)",
    org_ag_desc: "Organe suprême. Définit le programme d'action, élit le Bureau Exécutif et délibère sur tous les enjeux majeurs. Quorum : 3/4 des membres.",
    org_be_title: "Bureau Exécutif (BE)",
    org_be_desc: "Gestion quotidienne des affaires. Élu par l'AG pour un mandat de 2 ans renouvelable.",
    org_cs_title: "Comité Spécialisé (CS)",
    org_cs_desc: "Appui technique et expertise sectorielle pour les projets et activités de l'organisation.",
    org_cc_title: "Commissaire aux Comptes (CC)",
    org_cc_desc: "Contrôle et audit financier, garant de la transparence dans la gestion des ressources.",
    bureau_tag: "Bureau Exécutif",
    bureau_title: "Composition du Bureau",
    bureau_president: "Présidente",
    bureau_vp: "Vice-Présidente",
    bureau_sg: "Secrétaire Général·e",
    bureau_sga: "SG Adjoint·e",
    bureau_rp: "Relations Publiques",
    bureau_rpa: "RP Adjoint·e",
    bureau_finance: "Affaires Financières",
    bureau_financea: "AF Adjoint·e",
    bureau_com: "Communication",
    bureau_coma: "Com. Adjoint·e",
    bureau_mob: "Mobilisation",
    bureau_moba: "Mob. Adjoint·e",
    bureau_women: "Affaires Femmes & Enfants",
    bureau_diaspora: "Diaspora tchadienne",
    bureau_youth: "Jeunesse & Sports",
    bureau_logistics: "Développement & Logistique",
    bureau_projects: "Préparation de projets",
    bureau_advisors: "Conseillers (×3)",

    // Ressources
    ressources_tag: "Financement",
    ressources_title: "Nos ressources",
    res1: "Droits d'adhésion et cotisations des membres",
    res2: "Participations et partenariats avec d'autres ONG",
    res3: "Subventions publiques et privées",
    res4: "Dons, legs et contributions volontaires",
    res5: "Pénalités, amendes et travaux d'intérêt commun",
    res_footer: "Tout mouvement de fonds est justifié par une pièce comptable signée par au moins 3 personnes habilitées (Présidente, Trésorière et Agent Financier).",

    // Membres
    members_tag: "Membres",
    members_title: "Droits et devoirs",
    duties_title: "Devoirs de chaque membre",
    duty1: "Acquitter sa cotisation régulièrement",
    duty2: "Participer aux réunions et à l'Assemblée Générale",
    duty3: "Respecter les statuts et le règlement intérieur",
    duty4: "S'abstenir de toute discrimination sociale, tribale, religieuse ou ethnique",
    duty5: "Défendre l'intérêt légal de l'organisation",
    duty6: "Participer aux travaux d'intérêt général du groupe",
    duty7: "Venir au secours des personnes sinistrées et réfugiées",
    rights_title: "Droits de chaque membre",
    right1: "Participer à l'AG et s'exprimer librement",
    right2: "Élire et être élu à tout poste de responsabilité",
    right3: "Poser des questions sur la gestion des biens",
    right4: "Exiger un compte rendu clair sur les acquisitions",
    right5: "Participer aux manifestations organisées par l'ONG",
    right6: "Faire partie d'organisations sœurs",
    right7: "Quitter librement l'organisation sans antécédent",

    // ═══════════════════════════════════════════════════════════
    // 🖼️ GALERIE - PHOTOS
    // ═══════════════════════════════════════════════════════════
    // Catégories Galerie
galerie_category_formation: "Formation",
galerie_category_orphelins: "Orphelins",
galerie_category_ramadan: "Ramadan",
galerie_category_evenement: "Événements",

// Catégories Vidéos
video_category_forage: "Forage",
video_category_ramadan: "Ramadan",
video_category_sacrifice: "Sacrifice",
    // Messages
    galerie_no_photos: "Aucune photo dans cette catégorie",
    galerie_photos_soon: "Les photos de nos activités seront bientôt disponibles.",
    galerie_info: "Les photos sont gérées par l'administrateur.",
    galerie_image_not_available: "Image non disponible",

    // ═══════════════════════════════════════════════════════════
    // 🎬 VIDÉOS
    // ═══════════════════════════════════════════════════════════
    video_tag: "Médias",
    video_title: "Nos vidéos",
    video_desc: "Retrouvez ici les vidéos de nos activités, événements et moments forts de l'OFD.",
    
    // Catégories de vidéos
    video_all: "🎬 Toutes",
    video_forage: "Forage",
    video_ramadan: "Ramadan",
    video_sacrifice: "Sacrifice",
    
    // Messages
    video_no_videos: "Aucune vidéo dans cette catégorie",
    video_soon: "Les vidéos de nos activités seront bientôt disponibles.",
    video_info: "Les vidéos sont gérées par l'administrateur.",
    video_not_available: "Vidéo non disponible",
    video_format_not_supported: "Format non supporté",

    // Adhésion
    adhesion_tag: "Rejoindre l'OFD",
    adhesion_title: "Devenir membre",
    adhesion_desc: "L'OFD est ouverte à toute personne physique ou morale jouissant de ses droits civiques, sans distinction sociale, tribale, régionale, religieuse ou clanique.",
    step1_title: "Demande manuscrite",
    step1_desc: "Rédigez une lettre de demande d'adhésion exprimant votre engagement envers les valeurs de l'OFD.",
    step2_title: "Agrément du Bureau Exécutif",
    step2_desc: "Votre dossier est examiné et approuvé par le Bureau Exécutif conformément au règlement intérieur.",
    step3_title: "Carte de membre",
    step3_desc: "Après agrément, vous recevez votre carte de membre. La cotisation est facultative selon vos capacités.",
    adhesion_btn: "Nous contacter pour adhérer",

    // Contact
    contact_tag: "Nous joindre",
    contact_title: "Contact",
    contact_address_label: "Adresse",
    contact_address: "Quartier Amriguebé (Rue de 40m), N'Djamena – Tchad",
    contact_phone_label: "Téléphone",
    contact_phone: "(+235) 66 79 35 10 / 91 14 79 24<br>",
    contact_email_label: "Email",
    contact_email: "pdg@ofdev.org",
    contact_auth_label: "Autorisation de fonctionner",
    contact_auth: "Registre : Folio N°20/060 du 25/05/2020",
    message_tag: "Message",
    message_title: "Écrivez-nous",
    form_name: "Nom complet",
    form_name_placeholder: "Votre nom",
    form_email: "Adresse email",
    form_email_placeholder: "votre@email.com",
    form_subject: "Objet",
    form_subject_placeholder: "Adhésion / Partenariat / Information…",
    form_message: "Message",
    form_message_placeholder: "Votre message…",
    form_submit: "Envoyer le message",

    // Présidence
    presidence_tag: "Présidence",
    presidence_name: "Mme Hadjé Naguiyé Daoud",
    presidence_title: "Présidente Fondatrice",
    presidence_desc1: "Mme Hadjé Naguiyé Daoud est la Présidente Fondatrice de l'Organisation des Femmes pour le Développement (OFD). Engagée depuis plus de deux décennies dans la lutte pour l'émancipation des femmes et le développement communautaire, elle incarne la vision et la détermination qui animent l'OFD.",
    presidence_desc2: "Sous sa direction, l'OFD est devenue un acteur incontournable du développement socio-économique au Tchad, touchant des milliers de vies à travers des programmes de formation, d'autonomisation et de solidarité.",
    presidence_quote: "La force d'une nation ne se mesure pas à ses richesses, mais à la manière dont elle élève ses femmes et protège ses plus vulnérables.",
    presidence_years: "Années d'engagement",
    presidence_women: "Femmes autonomisées",
    presidence_projects: "Projets réalisés",

    // Footer
    footer_brand: "Organisation des Femmes pour le Développement — منظمة النساء من أجل التنمية<br>N'Djamena, République du Tchad",
    footer_nav: "Navigation",
    footer_org: "Organisation",
    footer_statuts: "Statuts & Règlement",
    footer_bureau: "Bureau Exécutif",
    footer_ag: "Assemblée Générale",
    footer_ressources: "Ressources",
    footer_copyright: "© 2024 OFD – Organisation des Femmes pour le Développement. Tous droits réservés."
  },

  // ═══════════════════════════════════════════════════════════
  // 🌍 ENGLISH
  // ═══════════════════════════════════════════════════════════
  en: {
    // Navigation
    nav_title: "Women's Organization for Development",
    nav_mission: "Mission",
    nav_objectifs: "Objectives",
    nav_structure: "Structure",
    nav_galerie: "Gallery",
    nav_videos: "Videos",
    nav_adhesion: "Membership",
    nav_contact: "Contact",
    nav_presidence: "Presidency",

    // Hero
    hero_eyebrow: "Will · Solidarity · Development",
    hero_title1: "United women",
    hero_title2: "for a <em>prosperous Chad</em>",
    hero_desc: "OFD is a secular, apolitical, non-profit organization founded in N'Djamena, carrying the voices of women and vulnerable communities since 2015.",
    hero_btn1: "Join the NGO",
    hero_btn2: "Discover our mission",

    // Stats
    stat_foundation: "Year of foundation",
    stat_duration: "Duration of the organization",
    stat_headquarters: "Headquarters · Chad",

    // Devise
    devise_tag: "Our motto",
    devise_title: "Three words, one vision",
    devise_will_title: "Will",
    devise_will_desc: "An active force that motivates every woman, every young person to take their destiny in hand and commit to a better reality.",
    devise_solidarity_title: "Solidarity",
    devise_solidarity_desc: "The moral bond that unites our community: moving forward together, hand in hand, without social, tribal or religious discrimination.",
    devise_dev_title: "Development",
    devise_dev_desc: "The sustainable ambition that drives every member to build, construct and achieve great things for the common good.",

    // Objectifs
    objectifs_tag: "Our objectives",
    objectifs_title: "What we build together",
    obj1: "Improve the socio-economic conditions of communities through the production, processing and marketing of agricultural and livestock products.",
    obj2: "Fight poverty through the optimal development of all sectors in the N'Djamena region and other regions of Chad.",
    obj3: "Protect the environment and fight climate change: water, air, soils, pastures, urban areas.",
    obj4: "Create vocational training centers: carpentry, IT, mechanics, agriculture, hairdressing, art and culture.",
    obj5: "Promote peaceful coexistence, peace and consolidate solidarity between associations and communities.",
    obj6: "Provide assistance to disaster victims and refugees, and prevent epidemics and other disasters.",
    obj7: "Promote entrepreneurship in all its forms and motivate young people in sustainable development projects.",
    obj8: "Fight delinquency, regional, tribal and religious divisions, and strengthen fraternal ties.",

    // Structure
    structure_tag: "Governance",
    structure_title: "Structure and functioning",
    structure_desc: "OFD is structured around four main bodies, each with specific responsibilities to ensure transparent and effective management.",
    org_ag_title: "General Assembly (GA)",
    org_ag_desc: "Supreme body. Defines the action program, elects the Executive Board and deliberates on all major issues. Quorum: 3/4 of members.",
    org_be_title: "Executive Board (EB)",
    org_be_desc: "Daily management of affairs. Elected by the GA for a renewable 2-year term.",
    org_cs_title: "Specialized Committee (SC)",
    org_cs_desc: "Technical support and sectoral expertise for the organization's projects and activities.",
    org_cc_title: "Audit Committee (AC)",
    org_cc_desc: "Financial control and audit, guarantor of transparency in resource management.",
    bureau_tag: "Executive Board",
    bureau_title: "Board Composition",
    bureau_president: "President",
    bureau_vp: "Vice-President",
    bureau_sg: "Secretary General",
    bureau_sga: "Deputy SG",
    bureau_rp: "Public Relations",
    bureau_rpa: "PR Deputy",
    bureau_finance: "Financial Affairs",
    bureau_financea: "FA Deputy",
    bureau_com: "Communication",
    bureau_coma: "Com. Deputy",
    bureau_mob: "Mobilization",
    bureau_moba: "Mob. Deputy",
    bureau_women: "Women & Children Affairs",
    bureau_diaspora: "Chadian Diaspora",
    bureau_youth: "Youth & Sports",
    bureau_logistics: "Development & Logistics",
    bureau_projects: "Project Preparation",
    bureau_advisors: "Advisors (×3)",

    // Ressources
    ressources_tag: "Funding",
    ressources_title: "Our resources",
    res1: "Membership fees and contributions",
    res2: "Participations and partnerships with other NGOs",
    res3: "Public and private subsidies",
    res4: "Donations, bequests and voluntary contributions",
    res5: "Penalties, fines and community work",
    res_footer: "Any fund movement is justified by an accounting document signed by at least 3 authorized persons (President, Treasurer and Financial Officer).",

    // Membres
    members_tag: "Members",
    members_title: "Rights and duties",
    duties_title: "Duties of each member",
    duty1: "Pay membership fees regularly",
    duty2: "Participate in meetings and the General Assembly",
    duty3: "Respect the statutes and internal regulations",
    duty4: "Refrain from any social, tribal, religious or ethnic discrimination",
    duty5: "Defend the legal interest of the organization",
    duty6: "Participate in community work",
    duty7: "Provide assistance to disaster victims and refugees",
    rights_title: "Rights of each member",
    right1: "Participate in the GA and speak freely",
    right2: "Vote and be elected to any position of responsibility",
    right3: "Ask questions about asset management",
    right4: "Request a clear report on acquisitions",
    right5: "Participate in events organized by the NGO",
    right6: "Join sister organizations",
    right7: "Leave the organization freely without obligation",

    // ═══════════════════════════════════════════════════════════
    // 🖼️ GALLERY - PHOTOS
    // ═══════════════════════════════════════════════════════════
      // Gallery Categories
galerie_category_formation: "Training",
galerie_category_orphelins: "Orphans",
galerie_category_ramadan: "Ramadan",
galerie_category_evenement: "Events",

// Video Categories
video_category_forage: "Water Drilling",
video_category_ramadan: "Ramadan",
video_category_sacrifice: "Sacrifice",
    // Messages
    galerie_no_photos: "No photos in this category",
    galerie_photos_soon: "Photos of our activities will be available soon.",
    galerie_info: "Photos are managed by the administrator.",
    galerie_image_not_available: "Image not available",

    // ═══════════════════════════════════════════════════════════
    // 🎬 VIDEOS
    // ═══════════════════════════════════════════════════════════
  // Videos - Titles and descriptions
video_forage_title: "Water Drilling",
video_forage_desc: "Helping a school in Chad",
video_ramadan_title: "Ramadan",
video_ramadan_desc: "Food distribution to needy families during Ramadan",
video_sacrifice_title: "Sacrifice",
video_sacrifice_desc: "Celebration of Eid al-Adha with families in need",

// Video Categories
video_category_forage: "Water Drilling",
video_category_ramadan: "Ramadan",
video_category_sacrifice: "Sacrifice",
    // Messages
    video_no_videos: "No videos in this category",
    video_soon: "Videos of our activities will be available soon.",
    video_info: "Videos are managed by the administrator.",
    video_not_available: "Video not available",
    video_format_not_supported: "Format not supported",

    // Adhésion
    adhesion_tag: "Join OFD",
    adhesion_title: "Become a member",
    adhesion_desc: "OFD is open to any natural or legal person enjoying their civil rights, without social, tribal, regional, religious or clan distinction.",
    step1_title: "Written request",
    step1_desc: "Write a letter of application expressing your commitment to OFD's values.",
    step2_title: "Executive Board approval",
    step2_desc: "Your application is reviewed and approved by the Executive Board in accordance with the internal regulations.",
    step3_title: "Member card",
    step3_desc: "After approval, you receive your member card. The contribution is optional according to your means.",
    adhesion_btn: "Contact us to join",

    // Contact
    contact_tag: "Contact us",
    contact_title: "Contact",
    contact_address_label: "Address",
    contact_address: "Amriguebé District (40m Street), N'Djamena – Chad",
    contact_phone_label: "Phone",
    contact_phone: "(+235) 66 79 35 10 / 91 14 79 24<br>",
    contact_email_label: "Email",
    contact_email: "pdg@ofdev.org",
    contact_auth_label: "Operating authorization",
    contact_auth: "Registry: Folio N°20/060 of 25/05/2020",
    message_tag: "Message",
    message_title: "Write to us",
    form_name: "Full name",
    form_name_placeholder: "Your name",
    form_email: "Email address",
    form_email_placeholder: "your@email.com",
    form_subject: "Subject",
    form_subject_placeholder: "Membership / Partnership / Information…",
    form_message: "Message",
    form_message_placeholder: "Your message…",
    form_submit: "Send message",

    // Présidence
    presidence_tag: "Presidency",
    presidence_name: "Ms. Hadjé Naguiyé Daoud",
    presidence_title: "Founding President",
    presidence_desc1: "Ms. Hadjé Naguiyé Daoud is the Founding President of the Women's Organization for Development (OFD). Committed for over two decades to the fight for women's emancipation and community development, she embodies the vision and determination that drive OFD.",
    presidence_desc2: "Under her leadership, OFD has become a key player in socio-economic development in Chad, touching thousands of lives through training, empowerment and solidarity programs.",
    presidence_quote: "The strength of a nation is not measured by its wealth, but by how it uplifts its women and protects its most vulnerable.",
    presidence_years: "Years of commitment",
    presidence_women: "Women empowered",
    presidence_projects: "Projects completed",

    // Footer
    footer_brand: "Women's Organization for Development — منظمة النساء من أجل التنمية<br>N'Djamena, Republic of Chad",
    footer_nav: "Navigation",
    footer_org: "Organization",
    footer_statuts: "Statutes & Regulations",
    footer_bureau: "Executive Board",
    footer_ag: "General Assembly",
    footer_ressources: "Resources",
    footer_copyright: "© 2024 OFD – Women's Organization for Development. All rights reserved."
  },

  // ═══════════════════════════════════════════════════════════
  // 🌍 العربية
  // ═══════════════════════════════════════════════════════════
  ar: {
    // Navigation
    nav_title: "منظمة النساء من أجل التنمية",
    nav_mission: "الرسالة",
    nav_objectifs: "الأهداف",
    nav_structure: "الهيكل",
    nav_galerie: "المعرض",
    nav_videos: "الفيديوهات",
    nav_adhesion: "العضوية",
    nav_contact: "اتصل بنا",
    nav_presidence: "الرئاسة",

    // Hero
    hero_eyebrow: "الإرادة · التضامن · التنمية",
    hero_title1: "نساء متحدات",
    hero_title2: "من أجل <em>تشاد مزدهر</em>",
    hero_desc: "منظمة OFD هي منظمة علمانية، غير سياسية، وغير ربحية، تأسست في إنجامينا، وتحمل أصوات النساء والمجتمعات الضعيفة منذ 2015.",
    hero_btn1: "انضم إلى المنظمة",
    hero_btn2: "اكتشف رسالتنا",

    // Stats
    stat_foundation: "سنة التأسيس",
    stat_duration: "مدة المنظمة",
    stat_headquarters: "المقر الرئيسي · تشاد",

    // Devise
    devise_tag: "شعارنا",
    devise_title: "ثلاث كلمات، رؤية واحدة",
    devise_will_title: "الإرادة",
    devise_will_desc: "قوة فعالة تحفز كل امرأة، كل شاب على أخذ مصيره بيده والالتزام من أجل واقع أفضل.",
    devise_solidarity_title: "التضامن",
    devise_solidarity_desc: "الرابط الأخلاقي الذي يوحد مجتمعنا: التقدم معًا، يدًا بيد، دون تمييز اجتماعي أو قبلي أو ديني.",
    devise_dev_title: "التنمية",
    devise_dev_desc: "الطموح المستدام الذي يدفع كل عضو إلى البناء والتحقيق لأجل الخير العام.",

    // Objectifs
    objectifs_tag: "أهدافنا",
    objectifs_title: "ما نبني معًا",
    obj1: "تحسين الظروف الاجتماعية والاقتصادية للمجتمعات من خلال إنتاج وتحويل وتسويق المنتجات الزراعية والرعوية.",
    obj2: "مكافحة الفقر من خلال التنمية المثلى لجميع القطاعات في منطقة إنجامينا والمناطق الأخرى من تشاد.",
    obj3: "حماية البيئة ومكافحة تغير المناخ: الماء، الهواء، التربة، المراعي، المناطق الحضرية.",
    obj4: "إنشاء مراكز للتكوين المهني: النجارة، الإعلام الآلي، الميكانيكا، الفلاحة، الحلاقة، الفن والثقافة.",
    obj5: "تعزيز التعايش السلمي والسلام وتوطيد التضامن بين الجمعيات والمجتمعات.",
    obj6: "مساعدة المتضررين واللاجئين، والوقاية من الأوبئة والكوارث الأخرى.",
    obj7: "تعزيز ريادة الأعمال بجميع أشكالها وتحفيز الشباب في مشاريع التنمية المستدامة.",
    obj8: "مكافحة الجريمة والانقسامات الجهوية والقبلية والدينية، وتعزيز روابط الأخوة.",

    // Structure
    structure_tag: "الحوكمة",
    structure_title: "الهيكل والأداء",
    structure_desc: "تتكون منظمة OFD من أربع هيئات رئيسية، لكل منها اختصاصات محددة لضمان إدارة شفافة وفعالة.",
    org_ag_title: "الجمعية العامة",
    org_ag_desc: "الهيئة العليا. تحدد برنامج العمل، تنتخب المكتب التنفيذي، وتتداول في جميع القضايا الكبرى. النصاب: 3/4 الأعضاء.",
    org_be_title: "المكتب التنفيذي",
    org_be_desc: "التسيير اليومي للشؤون. ينتخب من قبل الجمعية العامة لمدة سنتين قابلة للتجديد.",
    org_cs_title: "اللجنة المتخصصة",
    org_cs_desc: "الدعم التقني والخبرة القطاعية لمشاريع وأنشطة المنظمة.",
    org_cc_title: "مراقب الحسابات",
    org_cc_desc: "الرقابة والتدقيق المالي، ضمان الشفافية في تسيير الموارد.",
    bureau_tag: "المكتب التنفيذي",
    bureau_title: "تكوين المكتب",
    bureau_president: "الرئيسة",
    bureau_vp: "نائبة الرئيس",
    bureau_sg: "الأمين العام",
    bureau_sga: "نائب الأمين العام",
    bureau_rp: "العلاقات العامة",
    bureau_rpa: "نائب العلاقات العامة",
    bureau_finance: "الشؤون المالية",
    bureau_financea: "نائب الشؤون المالية",
    bureau_com: "الاتصال",
    bureau_coma: "نائب الاتصال",
    bureau_mob: "التعبئة",
    bureau_moba: "نائب التعبئة",
    bureau_women: "شؤون المرأة والطفل",
    bureau_diaspora: "الجالية التشادية",
    bureau_youth: "الشباب والرياضة",
    bureau_logistics: "التنمية واللوجستيك",
    bureau_projects: "إعداد المشاريع",
    bureau_advisors: "المستشارون (×3)",

    // Ressources
    ressources_tag: "التمويل",
    ressources_title: "مواردنا",
    res1: "رسوم العضوية واشتراكات الأعضاء",
    res2: "مشاركات وشراكات مع منظمات أخرى",
    res3: "الإعانات العامة والخاصة",
    res4: "التبرعات والوصايا والمساهمات الطوعية",
    res5: "الغرامات والعمل المجتمعي",
    res_footer: "أي حركة مالية تكون مبررة بوثيقة محاسبية موقعة من قبل 3 أشخاص مخولين على الأقل (الرئيس، أمين الصندوق والمسؤول المالي).",

    // Membres
    members_tag: "الأعضاء",
    members_title: "الحقوق والواجبات",
    duties_title: "واجبات كل عضو",
    duty1: "دفع الاشتراك بانتظام",
    duty2: "المشاركة في الاجتماعات والجمعية العامة",
    duty3: "احترام النظام الأساسي واللوائح الداخلية",
    duty4: "الامتناع عن أي تمييز اجتماعي أو قبلي أو ديني أو عرقي",
    duty5: "الدفاع عن المصلحة القانونية للمنظمة",
    duty6: "المشاركة في الأعمال ذات المصلحة العامة",
    duty7: "مساعدة المتضررين واللاجئين",
    rights_title: "حقوق كل عضو",
    right1: "المشاركة في الجمعية العامة والتعبير بحرية",
    right2: "الانتخاب والترشح لأي منصب مسؤولية",
    right3: "طرح أسئلة حول تسيير الممتلكات",
    right4: "طلب تقرير واضح عن المقتنيات",
    right5: "المشاركة في التظاهرات التي تنظمها المنظمة",
    right6: "الانضمام إلى منظمات شقيقة",
    right7: "مغادرة المنظمة بحرية دون التزامات",

    // ═══════════════════════════════════════════════════════════
    // 🖼️ المعرض - الصور
    // ═══════════════════════════════════════════════════════════
       // فئات المعرض
galerie_category_formation: "تدريب",
galerie_category_orphelins: "الأيتام",
galerie_category_ramadan: "رمضان",
galerie_category_evenement: "المناسبات",

// فئات الفيديوهات
video_category_forage: "حفر الآبار",
video_category_ramadan: "رمضان",
video_category_sacrifice: "الأضحية",
    
    // رسائل
    galerie_no_photos: "لا توجد صور في هذه الفئة",
    galerie_photos_soon: "ستكون صور أنشطتنا متاحة قريباً.",
    galerie_info: "الصور مدارة من قبل المسؤول.",
    galerie_image_not_available: "الصورة غير متاحة",

    // ═══════════════════════════════════════════════════════════
    // 🎬 الفيديوهات
    // ═══════════════════════════════════════════════════════════
    // الفيديوهات - العناوين والوصف
video_forage_title: "حفر الآبار",
video_forage_desc: "مساعدة مدرسة في تشاد",
video_ramadan_title: "رمضان",
video_ramadan_desc: "توزيع المواد الغذائية على الأسر المحتاجة خلال رمضان",
video_sacrifice_title: "الأضحية",
video_sacrifice_desc: "الاحتفال بعيد الأضحى مع العائلات المحتاجة",

// فئات الفيديوهات
video_category_forage: "حفر الآبار",
video_category_ramadan: "رمضان",
video_category_sacrifice: "الأضحية",
    
    // رسائل
    video_no_videos: "لا توجد فيديوهات في هذه الفئة",
    video_soon: "ستكون فيديوهات أنشطتنا متاحة قريباً.",
    video_info: "الفيديوهات مدارة من قبل المسؤول.",
    video_not_available: "الفيديو غير متاح",
    video_format_not_supported: "الصيغة غير مدعومة",

    // Adhésion
    adhesion_tag: "انضم إلى OFD",
    adhesion_title: "كن عضوًا",
    adhesion_desc: "OFD مفتوحة لأي شخص طبيعي أو اعتباري يتمتع بحقوقه المدنية، دون تمييز اجتماعي أو قبلي أو جهوي أو ديني أو عشائري.",
    step1_title: "طلب كتابي",
    step1_desc: "اكتب رسالة طلب عضوية تعبر عن التزامك بقيم OFD.",
    step2_title: "موافقة المكتب التنفيذي",
    step2_desc: "يتم دراسة ملفك والموافقة عليه من قبل المكتب التنفيذي وفقًا للوائح الداخلية.",
    step3_title: "بطاقة العضو",
    step3_desc: "بعد الموافقة، تستلم بطاقة عضويتك. الاشتراك اختياري حسب إمكانياتك.",
    adhesion_btn: "اتصل بنا للانضمام",

    // Contact
    contact_tag: "اتصل بنا",
    contact_title: "الاتصال",
    contact_address_label: "العنوان",
    contact_address: "حي أمريغويبي (شارع 40 متر)، إنجامينا – تشاد",
    contact_phone_label: "الهاتف",
    contact_phone: "(+235) 66 79 35 10 / 91 14 79 24<br>",
    contact_email_label: "البريد الإلكتروني",
    contact_email: "pdg@ofdev.org",
    contact_auth_label: "ترخيص العمل",
    contact_auth: "السجل: صفحة رقم 20/060 بتاريخ 25/05/2020",
    message_tag: "رسالة",
    message_title: "اكتب لنا",
    form_name: "الاسم الكامل",
    form_name_placeholder: "اسمك",
    form_email: "البريد الإلكتروني",
    form_email_placeholder: "بريدك@email.com",
    form_subject: "الموضوع",
    form_subject_placeholder: "عضوية / شراكة / معلومات...",
    form_message: "الرسالة",
    form_message_placeholder: "رسالتك...",
    form_submit: "إرسال الرسالة",

    // Présidence
    presidence_tag: "الرئاسة",
    presidence_name: "السيدة حاجة ناغوي داوود",
    presidence_title: "الرئيسة المؤسسة",
    presidence_desc1: "السيدة حاجة ناغوي داوود هي الرئيسة المؤسسة لمنظمة النساء من أجل التنمية (OFD). ملتزمة منذ أكثر من عقدين في النضال من أجل تحرير المرأة والتنمية المجتمعية، تجسد الرؤية والعزيمة التي تحرك المنظمة.",
    presidence_desc2: "تحت قيادتها، أصبحت OFD فاعلاً رئيسياً في التنمية الاقتصادية والاجتماعية في تشاد، ملمسة آلاف الأرواح من خلال برامج التدريب والتمكين والتضامن.",
    presidence_quote: "لا تُقاس قوة الأمة بثرواتها، بل بكيفية رفعتها لنسائها وحمايتها لأكثر الفئات ضعفاً.",
    presidence_years: "سنوات من الالتزام",
    presidence_women: "نساء تم تمكينهن",
    presidence_projects: "مشاريع منجزة",

    // Footer
    footer_brand: "منظمة النساء من أجل التنمية — Organisation des Femmes pour le Développement<br>إنجامينا، جمهورية تشاد",
    footer_nav: "التنقل",
    footer_org: "المنظمة",
    footer_statuts: "النظام الأساسي واللوائح",
    footer_bureau: "المكتب التنفيذي",
    footer_ag: "الجمعية العامة",
    footer_ressources: "الموارد",
    footer_copyright: "© 2024 OFD – منظمة النساء من أجل التنمية. جميع الحقوق محفوظة."
  }
};